import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	copyAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editFilter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changeOwner: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteFilter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	manageAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipWithName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	copyAction: {
		id: 'directories.filters-v2.main.content.cells.actions.copy-action',
		defaultMessage: 'Copy filter',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable copying of an existing filter',
	},
	editFilter: {
		id: 'directories.filters-v2.main.content.cells.actions.edit-filter',
		defaultMessage: 'Edit',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable editing of an existing filter',
	},
	changeOwner: {
		id: 'directories.filters-v2.main.content.cells.actions.change-owner',
		defaultMessage: 'Change owner',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable changing owner of an existing filter which they own',
	},
	deleteFilter: {
		id: 'directories.filters-v2.main.content.cells.actions.delete-filter',
		defaultMessage: 'Delete',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable deleting of an existing filter',
	},
	manageAction: {
		id: 'directories.filters-v2.main.content.cells.actions.manage-action',
		defaultMessage: 'Manage subscriptions',
		description:
			'Label displayed in the filters directory, when we click on meatball menu of the filters list item. To enable subscription settings of an existing filter',
	},
	tooltip: {
		id: 'directories.filters-v2.main.content.cells.actions.tooltip',
		defaultMessage: 'More',
		description: 'Tooltip for the meatball menu.',
	},
	tooltipWithName: {
		id: 'directories.filters-v2.main.content.cells.actions.tooltip-with-name',
		defaultMessage: 'More actions for {name}',
		description: 'Tooltip for the meatball menu when the filter name is available.',
	},
	moreActionsTooltip: {
		id: 'directories.filters-v2.main.content.cells.actions.more-actions-tooltip',
		defaultMessage: 'More actions',
		description: 'Tooltip for the meatball menu',
	},
});
export default messages;
